/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useMemo } from 'react';
import Loader from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { authSelectors } from '../../../app/auth/auth.selectors';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { deleteUser, enableUser } from '../../../app/page/page-storage/users/users.actions';
import { useApiRequestState } from '../../../utils/api.utils';
import { useSelect, useSelectWithParams } from '../../../utils/selector.utils';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { UserForm } from '../../pages/UserPage/UserForm';

import { ConnectedDialog } from '../ConnectedDialog';
import { IUserFormDialogProps } from './types';
import { UserDisableEnableButton } from './UserDisableEnableButton';

export const UserFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(dialogSelectors.selectDialogProps, 'userFormDialog') as IUserFormDialogProps;

  const [updateShowLoader, updateError] = useApiRequestState('updateUser');

  const showLoader = useMemo(() => updateShowLoader, [updateShowLoader]);
  const error = useMemo(() => updateError && !updateShowLoader, [updateError, updateShowLoader]);

  const onClose = useCallback(() => {
    dispatch(closeDialog('userFormDialog'));
  }, [dispatch]);

  const userId = props ? props.data?.id : undefined;
  const isUserDeleted = props?.data?.deleted === true;

  const isSuperAdmin = useSelect(authSelectors.selectUserIsAdmin);

  const onDeleteUser = useCallback(() => {
    if (userId) {
      dispatch(deleteUser(userId));
    }
  }, [dispatch, userId]);

  const onEnableUser = useCallback(() => {
    if (userId) {
      dispatch(enableUser(userId));
    }
  }, [dispatch, userId]);

  return (
    <ConnectedDialog dialogKey="userFormDialog">
      <div className="popup new_team_popup mid-popup isVisible">
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>{props?.data ? 'Edit contact' : 'Add contact'} </h3>
            <span className="close-popup close">
              {showLoader && <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />}
              {error && !showLoader && <p style={{ color: 'red' }}> Something went wrong </p>}
            </span>
          </div>
          <div className="panel-body pt-0" style={{ maxHeight: '500px' }}>
            <UserForm {...props} />
          </div>

          <div className="panel-footer no-border flex jcr">
            {userId && isSuperAdmin && (
              <UserDisableEnableButton isDeleted={isUserDeleted} onDisable={onDeleteUser} onEnable={onEnableUser} />
            )}
            <a className="link blueGray mr-2 close" title="" onClick={onClose}>
              Close
            </a>

            <SubmitButton apiKey="deleteUser" formName="user-form" text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
